module.exports = __webpack_public_path__ + "static/img/empty-pay.c8b380d0.png";